/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Arrow-Up': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4.5 7.917a.5.5 0 001 0V3.29l2.063 2.064a.5.5 0 00.708-.708L5.354 1.73a.5.5 0 00-.714.007l-2.91 2.91a.5.5 0 10.707.707L4.5 3.29v4.626z" _fill="#2D75F5"/>'
  }
})
